/**
 * Corner-radius tokens - ONE table for the `rounded` select of every widget.
 *
 * It used to live privately inside `BlockView`, which meant a widget rendered in
 * its own file could not reach it without either importing `BlockView` (a cycle)
 * or copying the table (drift). A pure module with no React and no registry
 * import, so anything under `render/` may use it.
 */

/** `rounded` token -> a CSS length for `border-radius`. */
export const ROUND_PX: Record<string, string> = {
  none: "0",
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "16px",
  "2xl": "24px",
  "3xl": "32px",
  full: "9999px",
};

/** A `rounded` prop value -> a CSS length. An unknown or missing value gives `md`. */
export function radiusOf(v: unknown): string {
  return ROUND_PX[typeof v === "string" ? v : "md"] ?? "8px";
}
